import React, { InputHTMLAttributes } from 'react'
import * as Styled from './Switch.styles'

interface CustomProps {
  /**
   * Sets size of the switch
   */
  size?: 'small' | 'large'
  /**
   * Sets checked state
   */
  checked?: boolean
  /**
   * Sets disabled state
   */
  disabled?: boolean
}

export type ComponentProps = CustomProps & Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>

const Switch: React.FC<ComponentProps> = React.forwardRef<HTMLInputElement, ComponentProps>(({ size = 'large', ...inputProps }, ref) => (
  <Styled.Container size={size}>
    <Styled.Input {...inputProps} ref={ref} type="checkbox" />
  </Styled.Container>
))

Switch.displayName = 'Switch'
export default Switch
